var modules_2b902d32 = {"container":"_1hxpc3f","alert":"_mw7k79","type-success":"_wz640k","type-info":"_1ml81b4","type-warning":"_1re8tpg","type-error":"_s9sstg"};
import "../../../assets/D4O7qLcb.css";

export { modules_2b902d32 as default };
//# sourceMappingURL=Notifications.module.less.js.map
